<!-- @ts-nocheck -->
<template>
  <div class="contact-list mt-4">
    <!-- Action Buttons -->
    <div class="d-flex justify-content-end mb-2">
      <button
        class="btn btn-sm btn-danger mr-2"
        :disabled="!hasSelected"
        @click="deleteSelected"
      >
        <i class="fas fa-trash-alt"></i>
        Delete Selected
      </button>
      <button
        class="btn btn-sm btn-outline-primary"
        type="button"
        @click="addRow"
      >
        <i class="fas fa-plus"></i>
        Add New Row
      </button>
    </div>

    <!-- Native Table -->
    <table class="table table-bordered align-middle">
      <thead class="thead-light">
        <tr>
          <th class="text-center">
            <b-form-checkbox
              type="checkbox"
              :checked="
                contacts?.every((c) => c?.selected) && contacts.length > 0
              "
              @change="toggleAll"
            />
          </th>
          <th>Name</th>
          <th>Department</th>
          <th>Job Title</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Mobile Phone</th>
          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(contact, index) in contacts" :key="index">
          <td class="text-center">
            <b-form-checkbox type="checkbox" v-model="contact.selected" />
          </td>
          <td>
            <b-input-group>
              <b-input-group-prepend>
                <b-form-select
                  v-model="contact.title"
                  :options="titleOptions"
                  class="bg-light"
                  style="
                    width: 66px;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                  "
                  size="sm"
                  plain
                />
              </b-input-group-prepend>
              <b-form-input
                v-model="contact.name"
                type="text"
                placeholder="Full Name"
                size="sm"
              />
            </b-input-group>
          </td>
          <td>
            <input
              v-model="contact.department"
              type="text"
              class="form-control"
            />
          </td>
          <td>
            <input
              v-model="contact.job_title"
              type="text"
              class="form-control"
            />
          </td>
          <td>
            <input v-model="contact.email" type="email" class="form-control" />
          </td>
          <td>
            <input v-model="contact.phone" type="text" class="form-control" />
          </td>
          <td>
            <input
              v-model="contact.mobile_phone"
              type="text"
              class="form-control"
            />
          </td>
          <td class="text-center">
            <button
              class="btn btn-sm btn-link text-danger p-0"
              @click="deleteRow(index)"
              type="button"
            >
              <i class="fas fa-trash-alt"></i>
            </button>
          </td>
        </tr>

        <!-- Empty State -->
        <tr v-if="!contacts || contacts.length === 0">
          <td colspan="8" class="text-center py-4">
            <div class="empty-state">
              <i
                class="fas fa-users text-muted mb-3"
                style="font-size: 3rem"
              ></i>
              <h6 class="text-muted mb-2">No Contacts Added</h6>
              <p class="text-muted mb-3">
                Start by adding your first contact person
              </p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'FormVendorListContact',
  props: {
    contacts: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      titleOptions: [
        { value: 'Mr', text: 'Mr' },
        { value: 'Mrs', text: 'Mrs' },
        { value: 'Ms', text: 'Ms' },
        { value: 'Miss', text: 'Miss' }
      ]
    }
  },
  computed: {
    hasSelected() {
      return (this.contacts || []).some((c) => c.selected)
    },
  },
  methods: {
    emitContacts(next) {
      this.$emit('update:contacts', next)
    },
    addRow() {
      this.contacts.push({
        selected: false,
        title: 'Mr',
        name: '',
        department: '',
        job_title: '',
        email: '',
        phone: '',
        mobile_phone: '',
      })
    },
    deleteRow(index) {
      this.contacts.splice(index, 1)
    },
    deleteSelected() {
      this.$emit('deleteBulk')
    },
    toggleAll(value) {
      if (this.contacts && this.contacts.length > 0) {
        this.contacts.forEach((c) => {
          c.selected = value
        })
      }
    },
  },
}
</script>

<style scoped>
.table input.form-control {
  height: 32px;
  font-size: 0.875rem;
  padding: 2px 8px;
}

.empty-state {
  padding: 2rem 1rem;
}

.empty-state i {
  opacity: 0.6;
}

.empty-state h6 {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.empty-state p {
  font-size: 0.875rem;
  margin-bottom: 1rem;
}
</style>
